import React, { Component } from 'react';

import './style.css';

import Header from '../Header';
import Footer from '../Footer';

class TermsAndConditions extends Component {


  render() {
    //const { className, ...props } = this.props;
    return (
      <div className='Home'>
        <Header></Header>
        <div className="privacyPolicy">
          <h3>Welcome to our website.</h3>
          <p>Welcome to our website. The term ' Right Track Admizzionz Campuz Private Limited ' or ‘Admizzionz Campuz’ or 'us' or 'we' refers to the owner of the website <a href=" www.admissionsalert.com"> www.admissionsalert.com </a> whose registered office is S1, S2, S3, 93 Adarshini Plaza, Adchini Village, Sri Aurobindo Marg, New Delhi 110017. Our company registration number is U80220DL2010PTC210984 and place of registration is New Delhi. The term 'you' refers to the user of this website.</p>

          <p>The services offered by us through this website are subject to the following terms and conditions:</p>

          <ol>
            <li value="1">
           Admizzionz Campuz is a facilitator, providing alerts on Indian undergraduate colleges admission processes milestones and notifications, to the users of the website<a href="www.admissionsalert.com">www.admissionsalert.com</a> Information is also provided on scholarships, Olympiads in India and popular careers.
          </li>
          <li> 
           These alerts and other information provided by the website <a href="www.admissionsalert.com">www.admissionsalert.com</a> is based on disclosures made by the institution and publicly available information about it, and the best efforts of Admizzionz Campuz® to verify the information. Admizzionz Campuz® is not responsible any misinformation, errors or ad hoc changes in the information provided. Also, at no point Admizzionz Campuz® guarantees that the information provided is exhaustive.            
           </li>

          <li> 
           Admizzionz Campuz will not entertain any queries from the users of  <a href="www.admissionsalert.com">www.admissionsalert.com</a>  regarding the admission processes being followed by different institutions. Admizzionz Campuz will also not address any queries that will help the user evaluate courses and colleges for gaining admission.             
           </li>

          <li> 
           Admizzionz Campuz® adheres to the admission criteria laid down by the institution. The final decision of granting admission to an applicant rests solely with the institution. Admizzionz Campuz® will not entertain any queries from the users of <a href="www.admissionsalert.com">www.admissionsalert.com</a> regarding the specifics of the admission criteria followed by the individual institutions.            
          </li>

          <li>The admissions cycle would be different for different colleges and the requirements for forms issuance, filling and submission will be different and so the applicant will need to follow the guidelines of the college for filling the admission forms. Admizzionz Campuz® will not entertain any queries from the users of <a href="www.admissionsalert.com">www.admissionsalert.com</a> regarding the process of filling up the forms.</li>

          <li> All services enrolled are valid till 30th June of the year the user’s class XII board exam is held. </li>

          <li> Admizzionz Campuz® is a division of Right Track Admizzionz Campuz Private Limited.</li>
          <li> All disputes are subject to Delhi jurisdiction limits only.</li>
          </ol>
        </div>
        <Footer></Footer>
      </div>
    );
  }
}

export default TermsAndConditions;



/** WEBPACK FOOTER **
 ** ./src/components/TermsAndConditions/index.js
 **/